// @flow
import { createAction } from 'redux-actions';
type MerchantGroupResponse = Array<MerchantGroupBlob>;

export const fetchClients = createAction(
  '@client/fetch',
  (clientId: *) => clientId
);

export const storeClients = createAction(
  '@client/store',
  (payload: MerchantGroupResponse) => payload
);

export const selectClient = createAction(
  '@client/select',
  // $FlowIssue
  (payload: number) => payload
);

export const showClientMenu = createAction('@client/show-menu');
export const hideClientMenu = createAction('@client/hide-menu');



// WEBPACK FOOTER //
// ./src/containers/client/clientsActions.js